import { FETCH_DATA_FAILURE, FETCH_DATA_REQUEST, FETCH_DATA_SUCCESS } from "./actionTypes";

// List of API endpoints
const apiEndpoints = [
  'allCountriesDetail',
  "allTranslatedLanguages",
  "placeholderLanguage",
  "selectedPlaceholderLanguage",
  'allLanguages',
  'feedbackDetails',
  'totalFeedbackDetails',
  'startSessionDetails',
  'chatbotDetails',
  'getModel', 
  'feedbackCommentDetails',
  'showFeedback',
  'policySignDetails',
  'savePolicy',
  'dropdownDetails',
  'queryCardDetails',
  'filteredResponseDetails'
];

// Dynamically generate the initial state
const initialState = apiEndpoints.reduce((state, endpoint) => {
  state[endpoint] = {
    data: [],
    loading: false,
    error: null,
    isFailed: undefined,
  };
  return state;
}, {});

const apiReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return {
        ...state,
        [action.api]: {
          ...state[action.api],
          loading: true,
          error: null,
          isFailed: undefined,
        },
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        [action.api]: {
          data: action.payload || [],
          loading: false,
          error: null,
          isFailed: false,
        },
      };
    case FETCH_DATA_FAILURE:
      return {
        ...state,
        [action.api]: {
          ...state[action.api],
          loading: false,
          error: action.payload,
          isFailed: true,
        },
      };
    default:
      return state;
  }
};

export default apiReducer;